const Modularize = require('./Modularize');
const InjectStyle = require('./components/injectStyle');

const ModularizeWithStyles = (name, Component, style) => Modularize(name, typeof style === 'string' ? InjectStyle(Component, style) : Component);

module.exports = ModularizeWithStyles;
